import { UsergroupAddOutlined } from "@ant-design/icons";
import { CrudOp, roleAssignmentOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { RoleManagementView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator) => {
  const { evaluate } = authHelperCreator(roleAssignmentOverviewAuthScope);
  return evaluate(CrudOp.READ);
};

export const roleManagementViewKey = "app/role-management";
export const roleManagementViewModule: ViewModule = {
  viewKey: roleManagementViewKey,
  viewEl: <RoleManagementView/>,
  displayNameI18nKey: "app:roleManagementView.title",
  menuIconEl: <UsergroupAddOutlined/>,
  isAuthorized,
  translations,
};
